export enum SubMenuName {
  ADMINISTRATION_SETTINGS = "ADMINISTRATION_MENU",
  ADMIN_REVBELL = "ADMIN_REVBELL_MENU",
  CONFIGURATION = "CONFIGURATION",
  DEFAULT = "DEFAULT_MENU",
  FAVORITES = "FAVORITES_MENU",
  PILOTAGE_OPTIMISATION = "PILOTAGE_OPTIMISATION_MENU",
  REPORTING = "REPORTING_PERFORMANCE",
  MARKETPLACE = "MARKETPLACE",
  SUPPORT = "SUPPORT_RESOURCES",
  IA_NANCIE = "IA_NANCIE",
}

type BaseOption = {
  isDisable?: boolean;
  // Use especially in NestedMenu component but also use at null in SubMenu component to not display collapse interface
  menuLevel: number | null;
  name?: string;
  nestedOptions?: Option[];
  toTranslate: boolean;
  value: string;
};

export type InternalRedirection = BaseOption & {
  type: "internalRedirection";
  redirectionTo?: string;
  // Use this in ADMIN_SUBMENU_HIERARCHY to automatically add the item to menu
  forceAddToMenu?: boolean;
  // Use this in ADMIN_SUBMENU_HIERARCHY to specify that this menu is a configuration page (allow to determine wich main menu should be colored as activated)
  configMenu?: boolean;
  // Use this to true if you want add this in menu only if user is staff
  isStaff?: boolean;
  // Flag key that must be active (value "1") for this item to be enabled
  flagRequired?: string;
  // Use this to true to force using the template's translation key instead of the API's translated_name
  useTranslationKey?: boolean;
  // Use this to true to show a "New" chip next to the item's label
  isNew?: boolean;
};

export type UrlsLanguagesType = {
  urlFR?: string;
  urlAll: string;
};

export type ExternalRedirection = BaseOption &
  UrlsLanguagesType & {
    type: "externalRedirection";
    targetBlank: boolean;
  };

export type Option = InternalRedirection | ExternalRedirection;

export interface SubMenuType {
  [key: string]: Option[];
}
